import React from 'react';
import { useSelector } from 'react-redux';

// Own constants/actions/components
import ButtonFloat from 'components/button-float';
import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import ExperienciesInspireSection from 'containers/experiences-inspire';
import { items } from 'services/selectors/shopping-cart';

const ExperienceRevivePage = () => {
  const itemsCart = useSelector(items);
  return (
    <div>
      <ButtonFloat number={itemsCart.length} />
      <HeaderContainer />
      <ExperienciesInspireSection page="show" maxResults={99999999} />
      <FooterContainer />
    </div>
  );
};

export default ExperienceRevivePage;
